// @flow

import { currentDate, months } from './';

export type TableType = 'HISTORY' | 'BILLING';
export type TableFilterSettings = {
  mode: 'ALL' | 'MONTH',
  month: string,
  year: string,
};

export const getTableFilterSettings = (
  table: TableType
): TableFilterSettings => {
  let settings = localStorage.getItem(`${table}-Filter-Settings`);
  if (settings) {
    settings = JSON.parse(settings);
  } else {
    const d = currentDate();
    return {
      mode: 'ALL',
      month: months[d.month],
      year: d.year.toString(),
    };
  }
  return settings;
};

export const setTableFilterSettings = (
  table: TableType,
  tfs: TableFilterSettings
) => {
  localStorage.setItem(`${table}-Filter-Settings`, JSON.stringify(tfs));
};

export const resetTableFilterSettings = () => {
  localStorage.removeItem('HISTORY-Filter-Settings');
  localStorage.removeItem('BILLING-Filter-Settings');
};



// WEBPACK FOOTER //
// ./src/utils/localstorage.js